import React, { useContext } from 'react';
import classnames from 'classnames';
import { PapiDeviation } from '@wix/da-types-papi';
import { withTranslation, WithTranslation } from 'react-i18next';
import OverlayContext from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Standard/Overlay/OverlayContext';
import StandardThumb from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Standard';
import Button from '@wix/da-shared-react/pkg/Button';
import ThumbInfo from '@wix/da-shared-react/pkg/ThumbInfo';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import { Url } from '@wix/da-url';
import { MobileContext } from '@wix/da-shared-react/pkg/Context';
import DeviationPaywall from '../../_partials/paywalls/DeviationPaywall';

import s from './FeaturedDeviationThumb.scss';

export interface Props {
  deviation: PapiDeviation;
  width?: number;
  height?: number;
  isMobile?: boolean;
  showMatureContent?: boolean;
}

export const FeaturedDeviationThumb: React.SFC<Props & WithTranslation> = ({
  deviation: { title, author, deviationId, printId },
  deviation,
  width,
  height,
  t,
}) => {
  const isMobile = useContext(MobileContext);

  return (
    <div className={s['root']}>
      <ErrorBoundary>
        <DeviationPaywall
          premiumFolderData={deviation.premiumFolderData}
          contentOwner={deviation.author!}
        >
          <OverlayContext.Consumer>
            {value => (
              <OverlayContext.Provider
                value={{
                  ...value,
                  showAuthor: false,
                  showTitle: false,
                }}
              >
                <StandardThumb
                  deviation={deviation}
                  width={width}
                  height={height}
                />
              </OverlayContext.Provider>
            )}
          </OverlayContext.Consumer>
        </DeviationPaywall>
        <ThumbInfo
          height={82}
          urlDeviation={deviation}
          user={author!}
          title={title}
          extra={
            !!printId && (
              <Button
                className={classnames(!isMobile && s['btn-buy'])}
                view="b18"
                height="small"
                href={Url.printLink(deviationId!)}
              >
                {t('common.buy')}
              </Button>
            )
          }
        />
      </ErrorBoundary>
    </div>
  );
};
FeaturedDeviationThumb.displayName = 'FeaturedDeviationThumb';

export default withTranslation()(FeaturedDeviationThumb);
